import { buildFacetDesignOverride, overrideReadOnly } from 'Packages/FacetRest/FacetDesignOverride';
import { BigPicklistInput, BodyTextMedium } from 'Packages/FacetDesign/Components';

export default buildFacetDesignOverride()
  .nameOverride('description', {
    _component: () => BodyTextMedium,
  }, overrideReadOnly)
  .nameOverride('howYouFeelAboutMoney', {
    _component: () => BigPicklistInput,
  }, overrideReadOnly);
